<template>
	<div>
		<v-dialog v-model="theme_color_dialog" no-click-animation persistent scrollable content-class="select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width>Theme Color</v-subheader>
	        	</v-card-title>

	        	<v-divider></v-divider>

		        <v-card-text full-height nopadding>

			        <v-list nopadding>
			        	<div v-for="(item, index) in items" :key="index">
			        		<v-list-tile avatar @click="updateThemeColor(item)">
			        			<v-list-tile-avatar style="min-width:40px;margin-right:16px;" :style="{'background':item.colorCode}"></v-list-tile-avatar>
					            <v-list-tile-content>
					              <v-list-tile-title>{{item.name}}</v-list-tile-title>
					            </v-list-tile-content>
					            <v-list-tile-action>
					              <v-icon v-if="item.colorCode == $parent.Form.themeColor">done</v-icon>
					            </v-list-tile-action>
				        	</v-list-tile>

				        	<v-divider v-if="items.length-1 != index"></v-divider>
			        	</div>

			        	<v-divider></v-divider>

			        	<v-list-tile avatar @click="openColorPicker('theme')">
		        			<v-list-tile-avatar style="min-width:40px;margin-right:16px;" :style="{'background':customColor}"></v-list-tile-avatar>
				            <v-list-tile-content>
				              <v-list-tile-title>Custom ({{customColor}})</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
				              <v-icon v-if="$parent.Form.customThemeColor">done</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>
			        	
			        </v-list>

		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['items', 'updateThemeColor', 'openColorPicker'],
		data(){
			return{
				theme_color_dialog:false,
				customColor:null
			}
		},
		methods:{
			openDialogWeb: function () {
				this.customColor = this.$parent.Form.themeColor;
				this.theme_color_dialog = true;
			},
			closeDialogWeb: function () {
				this.theme_color_dialog = false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/print_templates/dialogs/dialog_theme_color.vue